import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

const selectCockpitPartnerFlags = createSelector(
  selectFinancialCockpitState,
  ({ partnerFlags }) => partnerFlags
)

export const selectCockpitPartnerClassFlags = createSelector(
  selectCockpitPartnerFlags,
  (partnerFlags) => partnerFlags.filter(({ Type }) => Type === 'Class')
)
